import React, { useEffect } from 'react';

const faqs = [
  {
    q: 'Wann ist Tanken am günstigsten?',
    a: 'Laut einer ADAC-Auswertung ist der Sprit im Tagesverlauf kurz vor 12 Uhr mittags am günstigsten, eine zweite gute Gelegenheit ist der späte Nachmittag zwischen 17 und 18 Uhr. Am teuersten ist es meist kurz nach 7 Uhr morgens, während des Berufsverkehrs. Der Wochentag spielt dagegen kaum eine Rolle.',
  },
  {
    q: 'Wie oft ändern sich die Spritpreise?',
    a: 'Tankstellen passen ihre Preise häufig mehrmals täglich an, teils im Stundentakt. Jede Preisänderung muss dabei nahezu in Echtzeit an die Markttransparenzstelle für Kraftstoffe (MTS-K) gemeldet werden - genau diese Daten zeigt Ihnen Tankgünstig.de in Echtzeit an.',
  },
  {
    q: 'Was ist der Unterschied zwischen E5 und E10?',
    a: 'Beide Sorten sind bleifreies Super-Benzin mit 95 Oktan. Der Unterschied liegt im Bioethanol-Anteil: E5 enthält bis zu 5 %, E10 bis zu 10 % Ethanol. E10 ist meist etwas günstiger, ist aber nicht für jedes Fahrzeug freigegeben - ein Blick in die Bedienungsanleitung oder den Fahrzeugschein schafft Klarheit.',
  },
  {
    q: 'Wie viel Steuern stecken im Spritpreis?',
    a: 'Etwa die Hälfte des Preises an der Zapfsäule sind Steuern und Abgaben: die Energiesteuer (65,45 Cent/Liter bei Benzin, 47,04 Cent/Liter bei Diesel), 19 % Mehrwertsteuer auf den Gesamtbetrag sowie die CO₂-Abgabe von zuletzt rund 16 bis 17 Cent pro Liter.',
  },
  {
    q: 'Ist Tankgünstig.de wirklich kostenlos?',
    a: 'Ja, die Nutzung von Tankgünstig.de ist zu 100 % kostenlos - ohne Anmeldung, ohne versteckte Kosten. Ein Konto benötigen Sie nur, wenn Sie Lieblings-Tankstellen als Favoriten speichern möchten.',
  },
  {
    q: 'Woher stammen die Preisdaten?',
    a: 'Alle Preise stammen direkt von der Markttransparenzstelle für Kraftstoffe (MTS-K), einer beim Bundeskartellamt angesiedelten Institution. Tankstellen sind gesetzlich verpflichtet, jede Preisänderung nahezu in Echtzeit zu melden - so sehen Sie hier stets aktuelle Daten.',
  },
];

function FaqSection() {
  useEffect(() => {
    const scriptId = 'faq-jsonld';
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((item) => ({
        '@type': 'Question',
        name: item.q,
        acceptedAnswer: { '@type': 'Answer', text: item.a },
      })),
    });

    return () => {
      const s = document.getElementById(scriptId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="faq-section">
      <h2 className="section-heading">Häufige Fragen</h2>
      <div className="faq-list">
        {faqs.map((item, i) => (
          <details className="faq-item" key={i}>
            <summary className="faq-question">{item.q}</summary>
            <p className="faq-answer">{item.a}</p>
          </details>
        ))}
      </div>
    </div>
  );
}

export default FaqSection;
